var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"npsWrapper"},_vm._l((_vm.countArr),function(item,index){return _c('li',{key:index,class:_vm.selectedIndex === index ? 'selectedItem' : '',on:{"click":function($event){return _vm.choose(index)}}},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2302e68c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/vibrantRubikCube/runtime/dynamicAttr/nps.vue
// module id = null
// module chunks = 